
export interface IPosition {
    start: number;
    end: number;
    line: number;
}

abstract class AstError {
    constructor(protected phase: string, protected code: string, protected message: string) {
        this.code = code;
        this.phase = phase;
        this.message = message;
    }
}


export class TokenGenerateError extends AstError {
    constructor(protected code: string, protected message: string, protected position: IPosition) {
        super('GenerateToken', code, message);
        this.position = position;
    }
}


export class TokenValidateError extends AstError {
    constructor(protected code: string, protected message: string, protected position: IPosition) {
        super('ValidateToken', code, message);
        this.position = position;
    }
}


export class TokenComposeError extends AstError {
    constructor(protected code: string, protected message: string, protected position: IPosition) {
        super('ComposeToken', code, message);
        this.position = position;
    }
}

export class InferenceError extends AstError {
    constructor(protected code: string, protected message: string, protected position: IPosition) {
        super('Inference', code, message);
        this.position = position;
    }
}
